import React, { useRef, useState } from "react";

import { InfoIcon as Info, Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import Dialog from "ds/Dialog/Dialog";
import { Link } from "ds/Toast";
import { useClickOutside } from "Hooks/useClickOutside";
import { useObservabilitySuiteIntegrationList } from "src/organization/pages/project/settings/integrations/components/IntegrationForm/config";
import IntegrationButton from "src/organization/pages/project/settings/integrations/Details/components/IntegrationButton";

import { List } from "../GettingStarted.styles";

import * as S from "./style";

const ObservabilitySuiteList = () => {
  const { integrationConfig, isObserbilitySuiteEnabled, isBlackFireEnabled } =
    useObservabilitySuiteIntegrationList();

  const formatMessage = useIntl().formatMessage;
  const [openDialog, setOpenDialog] = useState<string | null>(null);
  const blackFireButtonRef = useRef(null);

  useClickOutside(blackFireButtonRef, () => {
    setOpenDialog(null);
  });

  return (
    <div>
      <S.TitleWrapper>
        <Typography.BodyText size="small" weight="semiBold">
          {formatMessage({
            id: "integration.getting_started.observability_suite_title"
          })}
        </Typography.BodyText>
        <Dialog
          description={formatMessage({
            id: "integration.getting_started.observability_suite_description"
          })}
          title={formatMessage({
            id: "integration.observability_suite.info_title"
          })}
          analyticId="integration.getting_started.observability_suite_description"
          trigger={
            <div role="button" tabIndex={0} aria-label="more-info">
              <Info width={24} fill="var(--icon-granite-fill,var(--granite))" />
            </div>
          }
          link={
            <Link
              href={formatMessage({ id: "links.observability-suite-features" })}
            >
              {formatMessage({
                id: "integration.observability_suit.info_learn_about"
              })}
            </Link>
          }
        />
      </S.TitleWrapper>
      <List ref={blackFireButtonRef}>
        {integrationConfig.map(config => {
          const isBlackFireConfig = config.type === "blackfire";
          const hasObsOrEnabledInConfig =
            isObserbilitySuiteEnabled || config.enabled;
          const blackFireConfigEnabled =
            isBlackFireEnabled && isBlackFireConfig;

          return !hasObsOrEnabledInConfig || isBlackFireConfig ? (
            <div>
              <Dialog
                open={openDialog === config.type}
                key={config.type}
                description={
                  config?.info?.description
                    ? formatMessage({ id: config?.info?.description })
                    : ""
                }
                title={
                  config?.info?.title
                    ? formatMessage({ id: config?.info?.title })
                    : ""
                }
                analyticId={config?.info?.description}
                trigger={
                  <div
                    role="button"
                    tabIndex={0}
                    aria-label="integration-button"
                  >
                    <IntegrationButton
                      disabled={
                        isBlackFireConfig
                          ? !blackFireConfigEnabled
                          : !hasObsOrEnabledInConfig
                      }
                      displayTooltip={isBlackFireConfig}
                      onClick={() => {
                        setOpenDialog(
                          openDialog == config.type ? "" : config.type
                        );
                      }}
                      integration={config}
                    />
                  </div>
                }
                link={
                  <S.IntegrationActionLinkWrapper>
                    {config.actionLinks?.map(l => (
                      <Link
                        key={formatMessage({ id: l.title })}
                        href={formatMessage({ id: l.href })}
                      >
                        {formatMessage({ id: l.title })}
                      </Link>
                    ))}
                  </S.IntegrationActionLinkWrapper>
                }
              />
            </div>
          ) : (
            <IntegrationButton key={config.type} integration={config} />
          );
        })}
      </List>
    </div>
  );
};

export default ObservabilitySuiteList;
